import React, { PropsWithChildren, useContext } from 'react';

const FieldSetContext = React.createContext(false);

export function useFieldSet() {
  return useContext(FieldSetContext);
}

export interface FormsFieldSetProps {
  disabled?: boolean;
}

export function FormsFieldSet(props: PropsWithChildren<FormsFieldSetProps>) {
  const { disabled, children } = props;

  return (
    <FieldSetContext.Provider value={!!disabled}>
      <fieldset disabled={!!disabled}>{children}</fieldset>
    </FieldSetContext.Provider>
  );
}
